function attachEmarsys() {
  $(function(){
    $('#email_signup_btn').click(function() {
      var email = $(this).parent().find('[name="email"]').val();
      trackEmarsys(email);
    });

    function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    function trackEmarsys(email) {
      var emailLowerCase = (typeof email === 'string') ? email.toLowerCase() : '';
      var $messageSuscription = $('#email_confirmation_message');
      var messages = {
        SUCCESS_MESSAGE: 'Thank you for subscribing!',
        FAIL_MESSAGE: 'There was an error, please try again.',
        INVALID_EMAIL: 'Please enter a valid email.'
      };

      if (emailLowerCase && validateEmail(emailLowerCase)) {
        heap.identify(emailLowerCase);
        Parse.Cloud.run('etrack', {email:email, event: 'Signup Footer'}).then(function (result) {
          var msg = (result.success) ? messages.SUCCESS_MESSAGE : messages.FAIL_MESSAGE;
          $messageSuscription.text(msg);
        });
      } else {
        $messageSuscription.text(messages.INVALID_EMAIL);
      }
    };

  });
}

function loadEmailSignup() {
  if(jQuery) {
    attachEmarsys();
  } else {
    window.setTimeout(loadEmailSignup, 500);
  }
}

loadEmailSignup();
